import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class'

import * as fieldComponents from '../../components/fields/short-text-v1/short-text-v1-index'

@Injectable({
    providedIn: 'root'
  })
export class ShortTextV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'short-text-v1';
    menuTitle: string = "Short Text";
    deprecated: boolean = false;

    /**
     * 
     * @param field the object data of the field
     * @returns ShortTextV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.ShortTextV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsShortTextV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsShortTextV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsShortTextV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }


    getSettingsComponentType(): Type<fieldComponents.SettingsShortTextV1FieldComponent> {
        return fieldComponents.SettingsShortTextV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillShortTextV1FieldComponent> {
        return fieldComponents.FillShortTextV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewShortTextV1FieldComponent>{ 
        return fieldComponents.ViewShortTextV1FieldComponent;
    }

}